import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import { ChevronRight } from 'lucide-react';
import { Permission } from '../../../utils/helpers/permissions';
import PermissionGate from '../../../utils/hooks/PermissionGate';
import { Questions } from './Components/Questions';

export const QuestionBank: React.FC = () => {
  return (
    <Box sx={{ minWidth: 0 }}>
      {/* Breadcrumb & Navigation */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          justifyContent: 'space-between',
          alignItems: { lg: 'center' },
          borderBottom: '1px solid',
          borderColor: 'divider',
          py: 1.5,
          gap: 1.5,
        }}
      >
        <Breadcrumbs
          separator={<ChevronRight size={14} color="#94a3b8" />}
          aria-label="breadcrumb"
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Questions
          </Typography>
          <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 700 }}>
            Question Bank
          </Typography>
        </Breadcrumbs>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          <PermissionGate
            requiredPermissions={[Permission.QUESTIONS_VIEW]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to="/pre-screen-bank"
              variant="caption"
              underline="hover"
              sx={{
                fontWeight: 700,
                color: 'primary.main',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'rgba(16, 185, 129, 0.08)' },
              }}
            >
              Pre Screen Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
            requiredPermissions={[Permission.JOB_VIEW]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to="/content-manager"
              variant="caption"
              underline="hover"
              sx={{
                fontWeight: 700,
                color: 'primary.main',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'rgba(16, 185, 129, 0.08)' },
              }}
            >
              Content Manager
            </Link>
          </PermissionGate>
          <PermissionGate
            requiredPermissions={[Permission.JOB_CREATE]}
            matchAnyPermission={false}
          >
            <Link
              component={RouterLink}
              to="/upload-file"
              variant="caption"
              underline="hover"
              sx={{
                fontWeight: 700,
                color: 'primary.main',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'rgba(16, 185, 129, 0.08)' },
              }}
            >
              Auto Generate Questions
            </Link>
          </PermissionGate>
        </Stack>
      </Box>

      {/* Info Notice Banner */}
      <Paper
        variant="outlined"
        sx={{
          mb: 2,
          p: 1.5,
          textAlign: 'center',
          bgcolor: 'action.hover',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          You can view all the questions that are used in all the assessments.
        </Typography>
      </Paper>

      <Box>
        <Questions />
      </Box>
    </Box>
  );
};

export default QuestionBank;
